module.exports = __webpack_public_path__ + "assets/noimage_a1f228de340fbe11ed4c7d3737cde65f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/Orders/noimage.jpg
// module id = 1237
// module chunks = 0